export default {
  meta: {
    title: '个人绩效报表（一鸣）'
  }
};
